<template>
  <div class="info-page">
    <crumbs title="企业认定自评" />
    <el-form
      :model="form"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <el-row
          :gutter="10"
          v-for="(item, index) in form.dataList"
          :key="index"
        >
          <el-col :span="24">
            <el-form-item :prop="'dataList.' + index + '.answer'">
              <div class="row-title">
                <span>{{ item.title }}</span>
              </div>
              <div class="row-content">
                <el-radio-group :value="item.answer">
                  <el-radio
                    v-for="(op, i) in item.option"
                    :key="i"
                    :label="op"
                    :class="{
                      line: item.isBlock
                    }"
                  ></el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "qualificationEvaluateInfo",
  data() {
    return {
      form: {
        dataList: [
          {
            title: "（一）从事特定细分市场时间达到2年以上",
            answer: "",
            option: ["是", "否"]
          },
          {
            title:
              "（二）上年度研发费用总额不低于100万元，且占营业收入总额比重不低于3%",
            answer: "",
            option: ["是", "否"]
          },
          {
            title:
              "（三）上年度营业收入总额在1000万元以上，或上年度营业收入总额在1000万元以下，但近2年新增股权融资总额（合格机构投资者的实缴额）达到2000万元以上",
            answer: "",
            option: ["是", "否"]
          },
          {
            title: "（四）是否满足下列条件之一",
            answer: "",
            isBlock: true,
            option: [
              "近三年获得过省级科技奖励，并在获奖单位中排名前三；或获得国家级科技奖励，并在获奖单位中排名前五",
              "近两年研发费用总额均值在1000万元以上",
              "近两年新增股权融资总额（合格机构投资者的实缴额）6000万元以上",
              "近三年进入“创客中国”中小企业创新创业大赛全国500强企业组名单",
              "不符合以上条件"
            ]
          }
        ]
      }
    };
  },
  created() {
    this.loadInfo();
  },
  methods: {
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      return this.form.dataList.map((item, idx) => {
        return {
          ...item,
          answer: data[idx]
        };
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("service", "getQualificationCountInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form.dataList = this.downloadProcessData(
            JSON.parse(res.dataList)
          );
        } else {
          this.$message.error(message);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  /deep/ .el-form {
    .row-title {
      display: flex;
      padding: 11px 0;
      line-height: 24px;
      font-size: 16px;
    }
    .row-content {
      padding-left: 48px;
    }
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__content {
        .el-radio-group {
          .el-radio {
            padding: 0;
            margin-right: 50px;
            line-height: 46px;
            font-size: 16px;
            &.line {
              display: block;
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
